import { Type } from '@warp-drive/core-types/symbols';
import Model, { attr, belongsTo } from '@ember-data/model';
import type PslfTemplateModel from './pslf-template';

export default class PslfFieldModel extends Model {
  @attr declare page: number;
  @attr declare fieldType: string;
  @attr declare label: string;
  @attr declare x: number;
  @attr declare y: number;
  @attr declare width: number;
  @attr declare height: number;
  @attr declare key: string;
  @attr declare value: string;
  @attr declare defaultValue: string;
  @attr declare required: boolean;

  @belongsTo('pslf-template', { async: false, inverse: 'pslfFields' })
  declare pslfTemplate: PslfTemplateModel;

  [Type] = 'pslf-field' as const;
}
